import React, { useState } from 'react';
import logo from '../../assets/logo.svg';
import { CardMedia } from '@mui/material';
import { useLocation } from 'wouter';
import { ToastVariant } from '../../types';
import { useSetRecoilState } from 'recoil';
import { toastDataAtom } from '../../tools/Atoms/atoms';
import TwindButton from '../../components/TwindButton';
import axiosInstance from '../../helper/axios';
import { setCookie } from '../../helper/cookie';
import IlaraInput from '../../components/IlaraInput';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { EMAIL_REGX_VALIDATION } from '../../tools/constants';
import { Visibility, VisibilityOff } from '@mui/icons-material';
const Login = () => {
  const [, setLocation] = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const setToastData = useSetRecoilState(toastDataAtom);
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      emailAddress: '',
      password: ''
    },
    validationSchema: Yup.object({
      emailAddress: Yup.string()
        .email('Valid email address is required')
        .required('Email is required')
        .matches(EMAIL_REGX_VALIDATION, 'Valid email address is required'),
      password: Yup.string().required('Password is required')
    }),
    onSubmit: async (values) => {
      setIsLoading(true);
      const requestBody = {
        email: values?.emailAddress,
        password: values?.password
      };
      try {
        axiosInstance
          .post('/auth/login', requestBody)
          .then((response: any) => {
            setIsLoading(false);
            // localStorage.setItem('AUTH_TOKEN', response.data?.token);
            setCookie('AUTH_TOKEN', response.data?.token);
            window?.location?.reload();
          })
          .catch((e) => {
            console.log(e.response.data);
            // If login failed
            setIsLoading(false);
            // Handle error, maybe display an error message
            setToastData({
              open: true,
              variant: ToastVariant.error,
              title: 'Error',
              description: e.response.data
            });
          });
      } catch (error) {
        // console.error('Error occurred:', error);
        setIsLoading(false);
        setToastData({
          open: true,
          variant: ToastVariant.error,
          title: 'Error',
          description: 'Some error occured while login!'
        });
        // Handle error, maybe display an error message
      }
    }
  });
  return (
    <div className="bg-ilara-blue-login flex flex-col items-center h-screen pt-24">
      <div className="flex items-center">
        <CardMedia sx={{ width: 100, height: 100 }} component="img" image={logo} alt="ilara logo" />
        <p className="ml-1 font-secondary-bold font-semibold text-3xl overflow-hidden whitespace-nowrap uppercase text-ilara-white">
          ILARA HEALTH
        </p>
      </div>
      <div className="bg-white p-8 rounded shadow-md w-full md:w-1/2 lg:w-1/3 mt-16">
        <h1 className="text-2xl font-bold mb-4 text-center">Login</h1>
        <form>
          <div className="mb-4">
            <IlaraInput
              placeholder="example@domain.com"
              value={validation?.values?.emailAddress}
              name="emailAddress"
              type="email"
              onChange={validation.handleChange}
              label="Email address*"
              error={
                validation?.touched?.emailAddress && validation?.errors?.emailAddress
                  ? validation?.errors?.emailAddress
                  : null
              }
              className="tablet:w-[96%] smallTablet:mb-2 smallTablet:!w-full"
            />
          </div>
          <div className="mb-6 relative">
            <IlaraInput
              placeholder="password"
              value={validation?.values?.password}
              name="password"
              type={showPassword ? 'text' : 'password'}
              onChange={validation?.handleChange}
              label="Password*"
              error={
                validation?.touched?.password && validation?.errors?.password
                  ? validation?.errors?.password
                  : null
              }
              className="tablet:w-[96%] smallTablet:mb-2 smallTablet:!w-full pr-10"
            />
            <div
              className={`absolute inset-y-0 right-0 flex items-center justify-center cursor-pointer mr-3 ${
                validation?.touched?.password && validation?.errors?.password ? 'mt-0' : 'mt-6'
              }`}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </div>
          </div>
          <div className="flex items-center justify-center">
            <TwindButton
              className={`bg-ilara-blue-login text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline ${
                isLoading ? 'opacity-50 pointer-events-none' : ''
              }`}
              onClick={(e) => {
                e?.preventDefault();
                validation?.handleSubmit();
              }}
              disabled={isLoading}
              variant="primary-login"
              loading={isLoading}
            >
              Login
            </TwindButton>
          </div>
        </form>
        <div className="flex flex-col items-center justify-center mt-4">
          <p
            className="text-gray-700 text-sm flex items-center justify-center  hover:text-blue-500 cursor-pointer"
            onClick={() => {
              setLocation('forgotpassword');
            }}
          >
            {`Forgot Password? `}&nbsp;{' '}
            <div
              className="text-blue-500 cursor-pointer"
              onClick={() => {
                setLocation('signup');
              }}
            ></div>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
